export const ToPersian =  string =>{
    const numbers = ['۰','۱','۲','۳','۴','۵','۶','۷','۸','۹'];
    string=string.replace(/[0-9]/g, (index)=>{
        return numbers[index];
    });
    string=string.replace(/٤/g,'۴');
    string=string.replace(/٥/g,'۵');
    return string;
};